import { GET } from 'redux/modules/address-suggestion/actions/types';
import {
  reportAddressSuggestionSearch,
  reportAddressSuggestionSearchResultSet,
} from 'redux/modules/address-suggestion/actions';

import addressSuggestion from 'api/definitions/address-suggestion';

const iHandleStatusCodes = [400, 500, 503, 504];

export const searchAddresses = text => dispatch => {
  if (text && text.length > 4) {
    dispatch(reportAddressSuggestionSearch());
    return dispatch({
      types: GET.triplet,
      apiCall: addressSuggestion.get({ text, iHandleStatusCodes }),
      searchTerm: text,
    });
  }
  return Promise.resolve();
};

export const searchAddressesResultSet = resultSet => dispatch => {
  dispatch(reportAddressSuggestionSearchResultSet());
  return dispatch({
    types: GET.triplet,
    apiCall: addressSuggestion.get({
      text: '',
      resultSet,
      iHandleStatusCodes,
    }),
    resultSet,
  });
};
